/**
 * Reordena un array moviendo un elemento de una posición a otra
 * @param list - Array a reordenar
 * @param startIndex - Índice de inicio del elemento a mover
 * @param endIndex - Índice de destino
 * @returns Nuevo array reordenado
 */
export const reorder = <T>(list: T[], startIndex: number, endIndex: number): T[] => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);
  return result;
};

/**
 * Mueve un elemento a una nueva posición en el array
 * @param array - Array a reordenar
 * @param from - Índice de inicio
 * @param to - Índice de destino
 * @returns Nuevo array reordenado
 */
export const moveItem = <T>(array: T[], from: number, to: number): T[] => {
  if (from === to) return array;
  if (from < 0 || from >= array.length || to < 0 || to >= array.length) {
    return array;
  }
  return reorder(array, from, to);
};

/**
 * Encuentra el índice de un elemento en el array por su ID
 * @param items - Array de items
 * @param id - ID del item a buscar
 * @param idKey - Nombre de la propiedad que contiene el ID
 * @returns Índice del item o -1 si no se encuentra
 */
export const findItemIndex = <T extends Record<string, unknown>>(
  items: T[],
  id: string,
  idKey: string = 'id',
): number => {
  return items.findIndex((item) => item[idKey] === id);
};
